import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

export default function Dashboard() {
  const [stats, setStats] = useState({
    totalOrders: 0,
    totalRevenue: 0,
    totalEnrollments: 0,
    totalChildren: 0,
    todayOrders: 0,
    todayRevenue: 0
  })
  const [recentOrders, setRecentOrders] = useState([])
  const [opsData, setOpsData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // Fetch recent orders
    fetch(`${API}/orders`, {
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('cms_token') || localStorage.getItem('boxiaotu_token') || ''}` }
    })
      .then(r => r.json())
      .then(data => {
        if (data.success) {
          setRecentOrders((data.data || []).slice(0, 10))
        }
      })
      .catch(err => console.error('获取订单失败', err))

    // Fetch ops dashboard data
    fetch(`${API}/ai-videos/dashboard-stats`, {
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('cms_token') || localStorage.getItem('boxiaotu_token') || ''}` }
    })
      .then(r => r.json())
      .then(data => {
        if (data.success) {
          setOpsData(data.data)
          // Also populate stats from ops data
          setStats(prev => ({
            ...prev,
            totalOrders: data.data.orders?.total || 0,
          }))
        }
      })
      .catch(err => console.error('获取运营数据失败', err))
      .finally(() => setLoading(false))
  }, [])

  const formatCurrency = (n) => `¥${(n || 0).toLocaleString()}`

  // 图表颜色
  const colors = ['#1890ff', '#52c41a', '#fa8c16', '#722ed1', '#eb2f96']

  if (loading) return <div style={{ padding: 40, textAlign: 'center' }}>加载中...</div>

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h2 style={{ fontSize: 20, margin: 0 }}>📊 数据概览</h2>
      </div>

      {/* 上半部分：核心指标卡片 */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 24 }}>
        <div style={{ background: '#fff', borderRadius: 8, padding: 20, borderLeft: '4px solid #1890ff', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
          <div style={{ color: '#999', fontSize: 12 }}>🎬 AI动画总数</div>
          <div style={{ fontSize: 28, fontWeight: 600, color: '#1890ff' }}>{opsData?.aiVideos?.total ?? '-'}</div>
        </div>
        <div style={{ background: '#fff', borderRadius: 8, padding: 20, borderLeft: '4px solid #52c41a', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
          <div style={{ color: '#999', fontSize: 12 }}>📦 已支付订单</div>
          <div style={{ fontSize: 28, fontWeight: 600, color: '#52c41a' }}>{opsData?.orders?.total ?? '-'}</div>
        </div>
        <div style={{ background: '#fff', borderRadius: 8, padding: 20, borderLeft: '4px solid #fa8c16', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
          <div style={{ color: '#999', fontSize: 12 }}>📅 今日生成</div>
          <div style={{ fontSize: 28, fontWeight: 600, color: '#fa8c16' }}>{opsData?.aiVideos?.today ?? '-'}</div>
        </div>
        <div style={{ background: '#fff', borderRadius: 8, padding: 20, borderLeft: '4px solid #722ed1', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
          <div style={{ color: '#999', fontSize: 12 }}>📈 本周生成</div>
          <div style={{ fontSize: 28, fontWeight: 600, color: '#722ed1' }}>{opsData?.aiVideos?.week ?? '-'}</div>
        </div>
      </div>

      {/* 运营统计区块：两列布局 */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 24 }}>
        {/* 左列：AI动画趋势 */}
        <div style={{ background: '#fff', borderRadius: 8, padding: 20, boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
          <h3 style={{ margin: '0 0 16px 0', fontSize: 15 }}>📈 AI动画生成趋势（近14天）</h3>
          {opsData?.dailyTrend?.length > 0 ? (
            <div style={{ display: 'flex', alignItems: 'flex-end', gap: 6, height: 130, padding: '0 4px', marginTop: 10 }}>
              {(() => {
                const today = new Date()
                const days = []
                for (let i = 13; i >= 0; i--) {
                  const d = new Date(today)
                  d.setDate(d.getDate() - i)
                  const dateStr = d.toISOString().split('T')[0]
                  const found = (opsData.dailyTrend || []).find(t => t.date === dateStr)
                  days.push({ date: dateStr.slice(5), count: found?.count || 0, isToday: i === 0 })
                }
                const maxCount = Math.max(...days.map(d => d.count), 1)
                return days.map(d => (
                  <div key={d.date} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <div style={{ fontSize: 9, color: '#999', marginBottom: 2 }}>{d.count || ''}</div>
                    <div style={{
                      width: '100%',
                      maxWidth: 20,
                      height: Math.max((d.count / maxCount) * 70, 3),
                      background: d.isToday ? '#667eea' : (d.count > 0 ? '#a0aef0' : '#f0f0f0'),
                      borderRadius: '3px 3px 0 0',
                      transition: 'height 0.3s'
                    }} />
                    <div style={{ fontSize: 8, color: '#999', marginTop: 4, writingMode: 'vertical-lr', textOrientation: 'mixed', height: 12 }}>{d.date}</div>
                  </div>
                ))
              })()}
            </div>
          ) : (
            <div style={{ textAlign: 'center', padding: 40, color: '#999', fontSize: 13 }}>
              暂无趋势数据<br/>发布AI动画后将在次展示
            </div>
          )}
        </div>

        {/* 右列：网站流量 & 搜索来源 */}
        <div style={{ background: '#fff', borderRadius: 8, padding: 20, boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
          <h3 style={{ margin: '0 0 16px 0', fontSize: 15 }}>🌐 网站流量 & 搜索来源</h3>
          {opsData?.webTraffic ? (
            <>
              {/* 流量指标 */}
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12, marginBottom: 20 }}>
                <div style={{ textAlign: 'center', padding: 12, background: '#f0f5ff', borderRadius: 8 }}>
                  <div style={{ fontSize: 24, fontWeight: 700, color: '#1890ff' }}>{opsData.webTraffic.totalPV}</div>
                  <div style={{ fontSize: 11, color: '#666', marginTop: 2 }}>总访问(PV)</div>
                </div>
                <div style={{ textAlign: 'center', padding: 12, background: '#fff7e6', borderRadius: 8 }}>
                  <div style={{ fontSize: 24, fontWeight: 700, color: '#fa8c16' }}>{opsData.webTraffic.todayPV}</div>
                  <div style={{ fontSize: 11, color: '#666', marginTop: 2 }}>今日PV</div>
                </div>
                <div style={{ textAlign: 'center', padding: 12, background: '#f6ffed', borderRadius: 8 }}>
                  <div style={{ fontSize: 24, fontWeight: 700, color: '#52c41a' }}>{opsData.webTraffic.todayUV}</div>
                  <div style={{ fontSize: 11, color: '#666', marginTop: 2 }}>今日UV</div>
                </div>
              </div>

              {/* 搜索来源饼图 */}
              <div>
                <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 12 }}>🔍 访问来源分布</div>
                <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                  {/* 简易饼图 */}
                  <div style={{ width: 80, height: 80, borderRadius: '50%', position: 'relative', flexShrink: 0,
                    background: (() => {
                      const ref = opsData.webTraffic.referrerPercent
                      // 用conic-gradient做简易饼图
                      let parts = []
                      let cur = 0
                      const items = [
                        ['#1890ff', ref.direct || 0],
                        ['#52c41a', ref.baidu || 0],
                        ['#fa8c16', ref.google || 0],
                        ['#722ed1', ref.wechat || 0],
                        ['#eb2f96', ref.other || 0],
                      ]
                      return 'conic-gradient(' + items.map(([c, p]) => {
                        const start = cur
                        cur += p
                        return c + ' ' + start + '% ' + cur + '%'
                      }).join(', ') + ')'
                    })()
                  }}>
                    <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 40, height: 40, borderRadius: '50%', background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 600, color: '#333' }}>
                      {opsData.webTraffic.referrerPercent.direct || 0}%
                    </div>
                  </div>
                  {/* 图例 */}
                  <div style={{ flex: 1, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px 16px', fontSize: 12 }}>
                    {[
                      { label: '直接访问', value: opsData.webTraffic.referrerPercent.direct, color: '#1890ff' },
                      { label: '百度搜索', value: opsData.webTraffic.referrerPercent.baidu, color: '#52c41a' },
                      { label: '谷歌搜索', value: opsData.webTraffic.referrerPercent.google, color: '#fa8c16' },
                      { label: '微信', value: opsData.webTraffic.referrerPercent.wechat, color: '#722ed1' },
                      { label: '其他', value: opsData.webTraffic.referrerPercent.other, color: '#eb2f96' },
                    ].map(item => (
                      <div key={item.label} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        <div style={{ width: 8, height: 8, borderRadius: 2, background: item.color, flexShrink: 0 }} />
                        <span>{item.label}</span>
                        <span style={{ color: '#999', marginLeft: 'auto' }}>{item.value}%</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* 提示 */}
              <div style={{ marginTop: 12, fontSize: 11, color: '#bbb', borderTop: '1px solid #f0f0f0', paddingTop: 10 }}>
                💡 数据来源：Nginx访问日志（网页端）。已接入<strong style={{color:'#52c41a'}}>百度统计</strong>，详情请登录百度统计后台查看。
              </div>
            </>
          ) : (
            <div style={{ textAlign: 'center', padding: 40, color: '#999', fontSize: 13 }}>
              🌐 网站流量数据采集中<br/>
              <span style={{ fontSize: 11 }}>已接入百度统计，数据将在积累后显示</span>
            </div>
          )}
        </div>
      </div>

      {/* 最近订单表 */}
      <div style={{ background: '#fff', borderRadius: 8, padding: 20, boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
        <h3 style={{ margin: '0 0 16px 0', fontSize: 15 }}>📋 最近订单</h3>
        {recentOrders.length === 0 ? (
          <div style={{ padding: 40, textAlign: 'center', color: '#999' }}>暂无订单数据</div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#fafafa' }}>
                {['订单号', '孩子', '产品', '金额', '状态', '时间'].map(h => (
                  <th key={h} style={{ padding: '12px 8px', textAlign: 'left', fontSize: 13, color: '#666' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {recentOrders.map(o => (
                <tr key={o.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <td style={{ padding: '12px 8px', fontSize: 13 }}>{o.id || o.order_no || '-'}</td>
                  <td style={{ padding: '12px 8px', fontSize: 13 }}>{o.child_name || o.customer_name || '-'}</td>
                  <td style={{ padding: '12px 8px', fontSize: 13 }}>{o.product_name || o.title || '-'}</td>
                  <td style={{ padding: '12px 8px', fontSize: 13, color: '#f5222d' }}>¥{o.amount || o.price || 0}</td>
                  <td style={{ padding: '12px 8px', fontSize: 13 }}>
                    <span style={{
                      padding: '2px 8px', borderRadius: 10, fontSize: 11,
                      background: (o.status === 'paid' || o.payment_status === 'paid') ? '#52c41a' : (o.status === 'pending' ? '#faad14' : '#ff4d4f'),
                      color: '#fff'
                    }}>{o.status === 'paid' ? '已支付' : o.status === 'pending' ? '待支付' : o.status || o.payment_status || '-'}</span>
                  </td>
                  <td style={{ padding: '12px 8px', fontSize: 13, color: '#999' }}>{o.created_at || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  )
}
